export const initVariantType = {
  id: "",
  name: "",
  description: "",
  options: [],
}
